export default "__VITE_ASSET__BFZP9ErD__"